module.exports = __webpack_public_path__ + "img/exit.45046af0.svg";